if (!customElements.get("picker-tile")) {
  customElements.define(
    "picker-tile",
    class PickerTile extends HTMLElement {
      constructor() {
        super();
        this.bundlePickerDrawer = document.querySelector("product-drawer");
        this.actionButton = this.querySelector(".bundle-picker__tile-close");
        this.bundleAddToCart = document.querySelector("#AddToCart");
        this.drawerProductSelections = Array.from(
          document.querySelectorAll(".product-drawer__product-list")
        );
        this.associatedProductList = this.drawerProductSelections.find(
          (selection) => selection.dataset.selection === this.dataset.selection
        );
      }

      connectedCallback() {
        this.addEventListener("click", this.handleTileClick.bind(this));

        this.actionButton.addEventListener(
          "click",
          this.handleActionButton.bind(this)
        );
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleTileClick.bind(this));
        this.actionButton.removeEventListener(
          "click",
          this.handleActionButton.bind(this)
        );
      }

      handleTileClick() {
        this.bundlePickerDrawer.setAttribute(
          "data-current-product",
          this.dataset.position
        );

        this.drawerProductSelections.forEach((selection) => {
          selection.setAttribute("hidden", "");
        });

        this.associatedProductList.removeAttribute("hidden");
      }

      handleActionButton(event) {
        if (!this.actionButton.getAttribute("data-action")) {
          return;
        }

        switch (this.actionButton.getAttribute("data-action")) {
          case "remove":
            this.remove();
            break;
          case "replace":
            this.replaceContent();
            break;
          default:
            return;
        }
      }

      replaceContent() {
        const tileImage = this.querySelector(".bundle-picker__image");
        const titleHeading = this.querySelector(".tile__title-heading");
        const titleSubHeading = this.querySelector(".tile__title-subheading");

        this.removeAttribute("aria-checked");
        titleHeading.textContent = this.dataset.heading;
        titleSubHeading.textContent = this.dataset.subheading;
        tileImage.src = this.dataset.placeholderImage;
        this.bundleAddToCart.disabled = true;
        this.bundleAddToCart.classList.remove("button--primary");
        this.bundleAddToCart.classList.add("button--ternary");
        this.bundleAddToCart.querySelector(".loader-button__text").textContent =
          window.translations.bundles.chooseAllProducts;
      }
    }
  );
}

if (!customElements.get("drawer-filter")) {
  customElements.define(
    "drawer-filter",
    class DrawerFilter extends HTMLElement {
      constructor() {
        super();

        this.drawerProductList = this.closest(".product-drawer__product-list");
        this.itemsToFilter = Array.from(
          this.drawerProductList.querySelectorAll("[data-filter]")
        );
        this.filterValues = Array.from(
          this.querySelectorAll(".drawer-filter__value")
        );

        this.handleFilterClick = this.handleFilterClick.bind(this);
      }

      connectedCallback() {
        if (this.filterValues) {
          this.filterValues.forEach((value) => {
            value.addEventListener("click", () => {
              this.handleFilterClick(value);
            });
          });
        }
      }

      disconnectedCallback() {
        if (this.filterValues) {
          this.filterValues.forEach((value) => {
            value.removeEventListener("click", () => {
              this.handleFilterClick(value);
            });
          });
        }
      }

      handleFilterClick(value) {
        if (value.classList.contains("active")) {
          value.classList.remove("active");
        } else {
          this.filterValues.forEach((filterValue) => {
            filterValue.classList.remove("active");
          });
          value.classList.add("active");
        }
        const activeFilter = this.filterValues.find((filterValue) => {
          return filterValue.classList.contains("active");
        });

        this.hideItems(this.itemsToFilter);

        if (activeFilter) {
          const filteredItems = this.itemsToFilter.filter((item) => {
            return item.dataset.filter === activeFilter.dataset.value;
          });

          this.showItems(filteredItems);
        } else {
          this.showItems(this.itemsToFilter);
        }
      }

      hideItems(items) {
        items.forEach((item) => {
          const wrapper = item.closest(".product-drawer__item-wrapper");
          wrapper.setAttribute("hidden", "");
        });
      }

      showItems(items) {
        items.forEach((item) => {
          const wrapper = item.closest(".product-drawer__item-wrapper");
          wrapper.removeAttribute("hidden", "");
        });
      }
    }
  );
}

class ProductDrawer extends DrawerContent {
  constructor() {
    super();
    this.currentProduct = null;
  }

  connectedCallback() {
    super.connectedCallback();

    // This is for the normal products
    this.drawerItems = Array.from(
      this.querySelectorAll("[data-type='drawer-product']")
    );
    this.productTiles = Array.from(
      document.querySelectorAll("[data-tile='bundle-product']")
    );

    // This is for the optionalItems
    this.optionalProductTiles = Array.from(
      document.querySelectorAll("[data-tile='optional-product']")
    );
    this.optionalProductsWrapper = document.querySelector(
      ".optional-products .bundle-picker__wrapper"
    );

    if (this.optionalProductsWrapper) {
      this.originalOptionalTile = document
        .querySelector("[data-tile='optional-product']")
        .cloneNode(true);

      this.optionalItems = Array.from(
        this.querySelectorAll("[data-type='optional-product']")
      );
    }

    // This is for the add to cart
    this.bundleAddToCart = document.querySelector("#AddToCart");

    // This is for the quick view buttons
    this.quickViewLayer = this.querySelector(".product-drawer__quick-view");
    this.closeQuickViewLayer = this.quickViewLayer.querySelector(
      ".drawer__layer-close"
    );

    this.quickViewButtons = this.querySelectorAll(
      ".product-drawer__item-quick-view-button"
    );
    this.quickViewSlider = null;
    this.quickViewHeading = this.quickViewLayer.querySelector(
      "#QuickViewTitle"
    );
    this.quickViewAddButton =
      this.quickViewLayer.querySelector("#QuickViewAdd");

    this.addListeners();
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      const drawerContent = this.querySelector(".drawer__content");
      if (drawerContent) {
        drawerContent.scrollTop = 0;
      }
      const items = Array.from(
          this.querySelectorAll(".product-drawer__item:not([hidden]")
        ),
        effects = [];
      items.forEach((item) => (item.style.opacity = 0));
      effects.push(
        new ParallelEffect(
          items.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: ["translateX(40px)", "translateX(0)"],
              },
              {
                duration: 200, // Further reduced duration
                delay:
                  200 + 60 * index - Math.min(1 * index * index, 60 * index), // Reduced delay calculation
                easing: "cubic-bezier(0.25, 1, 0.5, 1)", // You can also consider simpler easing, like "ease-out"
              }
            );
          })
        )
      );
      let animation = new CustomAnimation(new ParallelEffect(effects));
      animation.play();
    }
  }

  async addListeners() {
    this.closeQuickViewLayer.addEventListener(
      "click",
      this.toggleQuickViewLayer.bind(this)
    );

    this.quickViewButtons.forEach((button) => {
      button.addEventListener("click", this.handleQuickView.bind(this));
    });
    this.quickViewAddButton.addEventListener("click", () => {
      this.handleBundleProductAssignment(this.quickViewAddButton);
      this.handleOptionalProductAssignment(this.quickViewAddButton);
      this.toggleQuickViewLayer();
    });
    
    if (
      !this.drawerItems.length ||
      !this.productTiles.length ||
      !this.bundleAddToCart
    ) {
      return;
    }

    this.drawerItems.forEach((product) => {
      product.addEventListener("click", () => {
        this.handleBundleProductAssignment(product);
      });
    });

    if (
      !this.optionalItems ||
      !this.optionalItems.length ||
      !this.optionalProductTiles.length
    ) {
      return;
    }

    this.optionalItems.forEach((product) => {
      product.addEventListener("click", () => {
        this.handleOptionalProductAssignment(product);
      });
    });
  }

  handleBundleProductAssignment(product) {
    this.currentProduct = this.dataset.currentProduct;

    const currentTile = this.productTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    // Assigning values only if elements exist
    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    currentTile.setAttribute("aria-checked", "true");

    // Refresh bundleTiles in case the DOM has changed
    this.productTiles = Array.from(
      document.querySelectorAll("[data-tile='bundle-product']")
    );

    if (this.productTiles.every((tile) => tile.hasAttribute("aria-checked"))) {
      if (this.bundleAddToCart) {
        this.bundleAddToCart.disabled = false;
        this.bundleAddToCart.classList.add("button--primary");
        this.bundleAddToCart.classList.remove("button--ternary");

        const loaderButtonText = this.bundleAddToCart.querySelector(
          ".loader-button__text"
        );
        if (loaderButtonText) {
          const addToCartText =
            window.translations?.product?.form?.addToCart || "Add to Cart";
          loaderButtonText.textContent = addToCartText;
        }
      }
    }
  }

  handleOptionalProductAssignment(product) {
    this.currentProduct = this.dataset.currentProduct;
    this.optionalProductTiles = Array.from(
      document.querySelectorAll("[data-tile='optional-product']")
    );

    const currentTile = this.optionalProductTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.price && currentTileVariantId) {
      currentTileVariantId.setAttribute("data-price", product.dataset.price);
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    if (currentTile.getAttribute("aria-checked") === "true") {
      return;
    }

    currentTile.setAttribute("aria-checked", "true");

    const newOptionalTile = this.originalOptionalTile.cloneNode(true);
    newOptionalTile.setAttribute(
      "data-position",
      `optional-product-${this.getNextFreeNumber(this.optionalProductTiles)}`
    );
    newOptionalTile.querySelector(
      "input"
    ).id = `optional-product-${this.getNextFreeNumber(this.optionalProductTiles)}`;
    this.optionalProductsWrapper.appendChild(newOptionalTile);
  }

  toggleQuickViewLayer() {
    if (this.quickViewLayer.hasAttribute("open")) {
      this.quickViewLayer.removeAttribute("open");
    } else {
      this.quickViewLayer.setAttribute("open", "");
    }
  }

  handleQuickView(event) {
    const quickViewData = event.target
      .closest(".product-drawer__item-wrapper")
      .querySelector(".product-drawer__item");

    const images = quickViewData
      ? JSON.parse(quickViewData.dataset.images)
      : null;
    const slides = images.map((image) => {
      return `
        <div class="swiper-slide">
          <img src="${image}">
        </div>
      `;
    });
    this.quickViewSlider = this.querySelector("swiper-element").swiperInstance;
    this.quickViewSlider.removeAllSlides();
    this.quickViewSlider.appendSlide(slides);
    this.quickViewSlider.update();
    this.quickViewSlider.slideTo(0);
    this.quickViewHeading.textContent = quickViewData.dataset.heading;
    this.quickViewAddButton.setAttribute(
      "data-image",
      quickViewData.dataset.image
    );
    this.quickViewAddButton.setAttribute(
      "data-variant-id",
      quickViewData.dataset.variantId
    );
    this.quickViewAddButton.setAttribute(
      "data-heading",
      quickViewData.dataset.heading
    );
    this.quickViewAddButton.setAttribute(
      "data-subheading",
      quickViewData.dataset.subheading
    );

    this.toggleQuickViewLayer();
  }

  getNextFreeNumber(optionalTiles) {
    const usedNumbers = Array.from(optionalTiles)
      .map((tile) => {
        const match = tile
          .getAttribute("data-position")
          ?.match(/optional-product-(\d+)/);
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((num) => num !== null);
    usedNumbers.sort((a, b) => a - b);
    let nextNumber = 1;
    for (const num of usedNumbers) {
      if (num === nextNumber) {
        nextNumber++;
      } else {
        break;
      }
    }

    return nextNumber;
  }
}

window.customElements.define("product-drawer", ProductDrawer);
